import { useState, useEffect } from "react"
import { Box, Text } from "@chakra-ui/react"
import { FaChevronDown } from "react-icons/fa"
import { AnimatePresence, motion } from "framer-motion"
import { Widget, WidgetHeader, WidgetBody } from "../../ui/Widget"
import useStore from "../../../store"
import UnitFilesRow from "./UnitFilesRow"
import { colors } from "../../../utilities/colors"

export default function UnitFiles({ unitId }) {
  const { unitFiles, fetchUnitFiles, unitFilesFetching } = useStore()
  const [showPhotos, setShowPhotos] = useState(false)

  useEffect(() => {
    fetchUnitFiles(unitId, { perPage: 100 })
  }, [unitId])

  const nonPhotoFiles = unitFiles?.filter((file) => !file.attributes.photo) ?? []
  const photoFiles = unitFiles?.filter((file) => file.attributes.photo) ?? []

  return (
    <Widget>
      <WidgetHeader title="Files" showSpinner={unitFilesFetching} />
      <WidgetBody>
        {nonPhotoFiles.map((file) => <UnitFilesRow key={file.id} file={file} />)}
        <AnimatePresence initial={false}>
          {showPhotos && photoFiles.length > 0 && (
            <motion.div
              key="photos"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2, ease: 'easeInOut' }}
              style={{ overflow: 'hidden' }}
            >
              {photoFiles.map((file) => <UnitFilesRow key={file.id} file={file} />)}
            </motion.div>
          )}
        </AnimatePresence>
        {photoFiles.length > 0 && (
          <Box
            as="button"
            type="button"
            w="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={2}
            py={1.5}
            borderTop="1px solid"
            borderColor={colors.grey700}
            color={colors.grey300}
            _hover={{ bg: colors.grey800 }}
            onClick={() => setShowPhotos((prev) => !prev)}
          >
            <Text fontSize="xs" fontWeight="semibold" letterSpacing="wide">
              {showPhotos ? 'Hide Photos' : 'Show Photos'}
            </Text>
            <Box
              as={FaChevronDown}
              size="12px"
              transform={showPhotos ? 'rotate(180deg)' : 'rotate(0deg)'}
              transition="transform 0.2s ease-in-out"
            />
          </Box>
        )}
      </WidgetBody>
    </Widget>
  )
}
